import React from 'react';
import './Footer.css';
import siteConfig from '../../resources/data/config.js';

function currentYear() {
  return new Date().getFullYear();
}

function JSCFooter() {
  return (
    <div className='footer'>
      <footer className="footer-inner">
        <p className='footer-address'>{siteConfig.address}</p>
        <p className='footer-copyright'>© {currentYear()} {siteConfig.name}. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default JSCFooter;